<template>
	<div class="case-color">
		<h5 class="case-color__heading">
			Case Color
		</h5>
		<div class="case-color__container">
			<div
				v-for="variant in variantsList"
				:key="variant.id"
				:class="{
					'case-color__color--selected': variant.id === currentVariantId,
					[`case-color__color--${variant.colors[0].toLowerCase()}`]: true
				}"
				class="case-color__color"
				@click="selectVariant(variant)"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: "CaseColorPicker",
	props: {
		variantsList: {
			type: Array,
			default() {
				return [];
			}
		},
		currentVariantId: {
			type: String,
			default: ""
		}
	},
	methods: {
		selectVariant(variant) {
			const isAlreadySelected = this.currentVariantId === variant.id;

			if (!isAlreadySelected) {
				this.$emit("select", variant);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.case-color {
	margin-bottom: 30px;

	&__heading {
		margin: 0 0 15px;
		color: #444259;
		font-size: 16px;
		font-weight: bold;
		letter-spacing: 0;
		text-transform: uppercase;
	}

	&__container {
		display: flex;
	}

	&__color {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		margin-right: 15px;
		margin-bottom: 10px;
		position: relative;
		display: flex;
		justify-content: center;
		cursor: pointer;

		&::after {
			content: "";
			height: 4px;
			width: 24px;
			border-radius: 1px;
			margin: 0 auto;
			position: absolute;
			bottom: -10px;
			transition: all 0.3s;
			opacity: 0;
		}

		&:hover {
			&::after {
				background-color: #e3e3e3;
				opacity: 1;
			}
		}
	}

	&__color--white {
		background: linear-gradient(180deg, #ffffff 0%, #e5e5e5 100%);
		box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
	}

	&__color--black {
		background: linear-gradient(180deg, #4b4b4b 0%, #000000 100%);
		box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.2);
	}

	&__color--selected {
		&::after {
			background-color: #8d29a0 !important;
			opacity: 1 !important;
		}
	}
}
</style>
